export const dadosMenu = [
    { texto: "Quem somos nós", url: "#" },
    { texto: "Política de privacidade", url: "#" },
    { texto: "Programa de fidelidade", url: "#" },
    { texto: "Nossas Lojas", url: "#" },
    { texto: "Quero ser franqueado", url: "#" },
    { texto: "Anuncie aqui", url: "#" },
]